<template>
  <v-footer color="#0E6CCD" class="footer-padding pb-10">
    <v-container class="my-0 py-0 pt-6">
      <v-row>
        <v-col cols="12" md="2">
          <router-link to="/">
            <v-img
              src="@/assets/images/medgate_logo_white.png"
              width="200px"
            ></v-img>
          </router-link>
        </v-col>
        <v-col cols="12" md="8" lg="6">
          <h3 class="pb-3">Telemedicine Center</h3>

          <table>
            <tr v-for="(contact, key) in contacts" :key="key">
              <td class="pr-5">{{ contact.label }}:</td>
              <td>
                <span
                  class="ma-0 pa-0 text-wrap"
                  v-for="(number, index) in contact.numbers"
                  :key="index"
                >
                  {{ number }}
                  <span v-if="contact.numbers.length - 1 != index"> / </span>
                </span>
              </td>
            </tr>
          </table>
        </v-col>
        <v-col cols="12" md="2" lg="4">
          <h3 class="pb-3">About Us</h3>

          <span v-for="(val, key) in shortcuts" :key="key">
            <a :href="val.link">
              <div class="d-flex">
                <span><v-icon color="#40ecb8">mdi-chevron-right</v-icon></span>
                <p class="text-hover">
                  {{ val.item }}
                </p>
              </div>
            </a>
          </span>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="6" lg="3" xl="3">
					<h3 class="pb-3">Download</h3>

					<div class="download">
						<v-btn
							rounded
							outlined
							large
							v-for="(val, key) in platforms"
							:key="key"
							class="mb-3"
							min-width="70%"
							color="white"
							:href="val.link"
							target="_blank"
						>
							<v-icon left>mdi-{{ val.icon }}</v-icon>
							{{ val.os }} App
						</v-btn>
					</div>

					<h3 class="pb-3 mt-2">Unsubscribe</h3>
					<div class="d-flex d-block">
						<v-icon color="#40ecb8">mdi-chevron-right</v-icon>
						<p class="text-hover ma-0 pa-0">
							Unsubscribe to our SMS
						</p>
					</div>
					<div class="d-flex">
						<span><v-icon color="#40ecb8">mdi-chevron-right</v-icon></span>
						<p class="text-hover ma-0 pa-0">
							Unsubscribe to our Newsletter
						</p>
					</div>
				</v-col> -->
      </v-row>

      <!-- <v-row no-gutters class="pt-10">

        <v-col
          v-for="(otherLink, key) in otherLinks"
          :key="key"
          cols="12"
          sm="6"
          md="3"
          lg="3"
          xl="3"
        >
          <a :href="otherLink.link">
            <p class="text-hover">{{ otherLink.name }}</p>
          </a>
        </v-col>
      </v-row> -->

      <ul>
        <li
        v-for="(otherLink, key) in otherLinks"
        :key="key">
          <a :href="otherLink.link">
            <p class="text-hover">{{ otherLink.name }}</p>
          </a>
      </li>
    </ul>

      <v-row justify="center">
        <div class="d-flex flex-no-wrap">
          <a
            v-for="(val, key) in medias"
            :key="key"
            :href="val.link"
            target="_blank"
          >
            <v-btn
              fab
              outlined
              color="white"
              :class="$vuetify.breakpoint.mdAndUp ? 'ma-4' : 'ma-2'"
              :small="MIXIN_SETUP_UI.isSmallButton"
              :medium="!MIXIN_SETUP_UI.isSmallButton"
            >
              <v-icon>mdi-{{ val.media }}</v-icon>
            </v-btn>
          </a>
        </div>
      </v-row>

      <v-row justify="center">
        <div class="text-center">
          <div class="d-block py-5">{{ medgateAddress }}</div>
          <div class="d-block">
            <span v-html="MIXIN_COPYRIGHT_SIGN"></span> Medgate
            {{ currentYear }}
          </div>
        </div>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { footerMenus, footerMedias, footerOtherLinks } from "@/config/menu.js";

import Repository from "@/api/repositories";
const FootersApi = Repository.get("footers");
import moment from "moment";

export default {
  data: () => ({
    contacts: [],
    shortcuts: footerMenus,
    platforms: [],
    medias: footerMedias,
    otherLinks: footerOtherLinks,
    medgateAddress:
      "4/F Dolmar Gold Tower, 107 C. Palanca Street, Legaspi Village, Makati City, 1229 Philippines"
  }),
  computed: {
    currentYear: function() {
      return moment().format("YYYY");
    }
  },
  mounted() {
    this.getContacts();
    this.setPlatforms();
  },
  methods: {
    async getContacts() {
      try {
        const { data } = await FootersApi.get();

        if (data) {
          var values = [];

          data.data.map(contact => {
            values = contact.values.contacts.map(value => {
              return {
                label: value.label,
                numbers: value.numbers
              };
            });
          });

          this.contacts = values;
        }

        console.log("[contacts]", data, this.contacts);
      } catch (error) {
        console.log(error);
      }
    },
    setPlatforms() {
      this.platforms = [
        {
          os: "iOS",
          icon: "apple",
          link: this.MIXIN_MEDGATE_APP_IOS_LINK
        },
        {
          os: "Android",
          icon: "android",
          link: this.MIXIN_MEDGATE_APP_ANDROID_LINK
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.v-footer {
  padding: 50px;

  div,
  h3,
  td,
  a,
  .v-btn__content {
    color: white !important;
  }

  .download {
    .v-btn {
      justify-content: left !important;
    }
  }

  ul {
      display: flex;
      list-style: none;
      justify-content: center;
      padding-top: 40px;

      li {
          // display: inline;
          list-style: none;
          padding: 10px 30px;
          text-align: -webkit-match-parent;

      }
  }

  @media (max-width: 699px) {

      ul {
          flex-direction: column;
          padding-left: 0;
          padding-bottom: 24px;
          padding-top: 0px;
      }
  }
}

//.footer-padding {
//  padding-left: 300px;
//  padding-right: 300px;
//}
//
//@media only screen and (max-width: 600px) {
//  .footer-padding {
//    padding: 0px;
//  }
//}
</style>
